module.exports = __webpack_public_path__ + "static/media/sovietantiair.574c0512.jpg";